
































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import requestService from "@/service/requestService";
import { SeibiItem, InspectionItem } from "@/model/InspectionSeibi";
import { Action, Getter } from "vuex-class";
import { Utils } from "@/service/util";
import { MESSAGE } from "@/model/Message";
import ConfirmDialog from "@/components/common/ConfirmDialog.vue";
import { UserService } from "@/service/UserService";
import { SocketControllers } from "@/service/SocketControllers";
import UserFooter from "@/components/UserFooter.vue";
import { JuuryouzeiJibaiseikiSave } from "@/model/JuuryouzeiJibaiseikiSave";
import { HikazeiRyoukin, Hikazei3 } from "@/model/RyoukinRank";
import { ElForm } from "element-ui/types/form";
import { ShakenShohiyou } from "@/model/ShakenShohiyou";

@Component({
  components: {
    ConfirmDialog,
    UserFooter
  },
  beforeRouteEnter(to, from, next) {
    if (from.path.indexOf("/workdetail") == -1) {
      window.sessionStorage.removeItem("shaken:v2:user:status-result-tab");
    }
    next();
  },
})
export default class StatusResult extends Vue {
  // @Action("setSeibiData", { namespace: "InspectSeibi" })
  // setSeibiData: any;

  @Getter("hasData", { namespace: "InspectSeibi" })
  hasData: boolean;

  @Getter("uketsukeCd", { namespace: "ReservationDetail" })
  uketsukeCd: string;
  @Getter("yoyakuNo", { namespace: "ReservationDetail" })
  yoyakuNo: string;
  @Getter("uketsukeExtendsId", { namespace: "ReservationDetail" })
  uketsukeExtendsId: number;
  @Getter("currentState", { namespace: "ReservationDetail" })
  reservationDetail: any;
  @Action("updateRyoukinRankCd", { namespace: "ReservationDetail" })
  updateRyoukinRankCd: any;

  @Action("setSeibiData", { namespace: "InspectSeibiAK3" })
  setSeibiAK3Data: any;

  @Getter("hasData", { namespace: "InspectSeibiAK3" })
  hasDataAK3: boolean;

  @Getter("listInspectAll", { namespace: "InspectSeibiAK3" })
  listInspect!: InspectionItem[];

  @Action("setProgressState", { namespace: "SubHeader" })
  setProgressState: any;

  @Getter("seibiAK3Loading", { namespace: "UserDataState" })
  isLoading: boolean;
  @Getter("seibiError", { namespace: "UserDataState" })
  seibiError: string;
  @Action("setError", { namespace: "UserDataState" })
  setError: any;

  @Action("updateInspect", { namespace: "InspectSeibiAK3" })
  updateInspect: any;

  @Action("updateDoTenken", { namespace: "InspectSeibiAK3" })
  updateDoTenken: any;

  @Action("updateInspectDoTenken", { namespace: "InspectSeibi" })
  updateInspectDoTenken: any;

  @Action("updateDoTenkenAndRecalculateInspect", { namespace: "InspectSeibi" })
  updateDoTenkenAndRecalculateInspect: any;

  @Action("updateTax", { namespace: "Shohiyou" })
  updateTax: any;

  @Getter("currentState", { namespace: "Shohiyou" })
  costData: ShakenShohiyou;

  @Getter("freeOfChargeLabelFull", { namespace: "FunctionSetting" })
  freeOfChargeLabel: any;

  public showAside: boolean = true;
  public currentTab: number = 1;

  public reqService: requestService;
  sktControll: SocketControllers;
  public checkList: any[] = [];
  loadingText: string = MESSAGE.Loading;
  errorMsg: string = "";
  isSave: boolean = false;
  displayDialogTax: boolean = false;
  isSetFormData: boolean = false;
  formData: JuuryouzeiJibaiseikiSave = {
    zeiJibaisekiMonthCnt: null,
    zkJibaisekiCd: null,
    zeiJibaisekiZn: null,
    zeiJibaisekiZk: null,
    zkWeightTaxCd: null,
    zeiWeightTax: null,
    zeiInshidaiZn: null,
    zeiInshidaiZk: null,
    zeiInshidaiGenka: null,
    ryoukinRankCd: null
  };
  listRyoukinRank: HikazeiRyoukin = { hikazei3: [], ryoukinRank: [] };
  rules = {
    zeiInshidaiZn: [{ validator: this.validateInshidai }],
    ryoukinRankCd: [{ validator: this.validateRyoukinRank }]
  };
  isExitConnectSocket: boolean = false;

  $refs!: {
    errorDialog: ConfirmDialog;
    taxForm: ElForm;
  };

  public utils: Utils = new Utils();

  get isError() {
    return this.seibiError != "";
  }

  onCloseError() {
    this.setError({ key: "seibi", value: "" });
  }

  get seibiAK3Length(): number[] {
    if (this.listInspect.length > 0) {
      return this.listInspect.map((e: any, index: number) => e.length);
    }
    return [0, 0, 0];
  }

  /*
   * 初期化関数
   * ( createdやmountedで1回だけ実行される必要があるが
   *   特定のパラメータが足りない時は実行順序を前後させる必要がある処理 )
   */
  @Watch("uketsukeCd")
  connectSocket() {
    // 必要な値が未セット、または初期化済みなら何もしない
    if (!this.uketsukeCd || this.isExitConnectSocket) { return; }
    this.isExitConnectSocket = true;

    this.sktControll = new SocketControllers(this);
    this.sktControll.socketEntry("inspectSubscription",this.onInspectItemcompleted); // catchSocket:ソケット仮04
    // catchSocket:13するしない後日編集
    this.sktControll.socketEntry("doTenkenSubscribe",this.onInspectionDotenken);
    this.sktControll.connectSocket();
  }

  created() {
    this.connectSocket();

    const savedTab = window.sessionStorage.getItem("shaken:v2:user:status-result-tab");
    if (savedTab) {
      this.currentTab = +savedTab;
    }
    this.getSeibi();
    if (!this.reservationDetail.sknUketsukeExtends || !this.reservationDetail.sknUketsukeExtends.ryoukinRankCd) {
      this.onShowTax(true);
    }
  }

  getSeibi() {
    this.reqService = new requestService();
    const userService = new UserService();
    if (!this.hasDataAK3 && !this.isLoading) {
      if (!this.reservationDetail.sknUketsukeExtends || !this.reservationDetail.sknUketsukeExtends.ryoukinRankCd) {
        userService.getAllData(false);
      } else {
        userService.getAllData();
      }
    } else {
      // 整備対象リスト用意(ユーザー側)
      userService.getSeibiAK3();
    }
  }

  onError(res: any) {
    this.errorMsg = this.utils.getHttpErrorMessage(res);
    this.$refs.errorDialog.onOpen();
  }

  gotoCustomer() {
    this.$router.push({
      name: "usercustomer",
      params: { code: this.yoyakuNo }
    });
  }

  isActive(index: number) {
    return this.currentTab === index;
  }

  selectTab(tab: number) {
    this.currentTab = tab;
    window.sessionStorage.setItem("shaken:v2:user:status-result-tab", String(this.currentTab));
  }

  onInspectItemcompleted(frame: any) {
  //  const body = this.utils.getWSData(frame);
  //  const seibi = { ...body };
  //  delete seibi.sknWorkProgressState;
  //  delete seibi.sknWorkProgressStateNm;
  //  this.setSeibiAK3Data(seibi);
    this.notify();
    // this.loopFirstDoTenken(this.listInspect[1]);
  }

//  onSeibiItemcompleted(frame: any) {
//    const body = this.utils.getWSData(frame);
//    const seibi = { ...body };
// /    delete seibi.items.sknWorkProgressState;
//    delete seibi.items.sknWorkProgressStateNm;
//    this.setSeibiData(seibi);
//  }

  onInspectionDotenken(frame: any) {
    if (this.isSave) {
      this.isSave = false;
    } else {
      this.notify();
      const body = this.utils.getWSData(frame);
      this.updateDoTenkenAndRecalculateInspect(body);
    }
    this.$forceUpdate();
  }

  notify() {
    this.$notify.info({
      title: "Info",
      message: MESSAGE.UpdatedInspections
    });
  }

  openWorkDetail(inspectItem: InspectionItem, index: number) {
    if (inspectItem.sknInspectId) {
      this.$router.push({
        name: "workdetail",
        query: {
          inspect: inspectItem.sknInspectId.toString(),
          index: index.toString()
        }
      });
    }
  }

  onImgError(item: InspectionItem) {
    item.img[0] = "";
    this.updateInspect(item);
    this.$forceUpdate();
  }

  changeDoTenken(item: InspectionItem, doTenken: any) {
    if (item.doTenken != doTenken) {
      item.doTenken = doTenken;
      this.updateInspect(item);
      this.updateInspectDoTenken(item);
      this.$forceUpdate();
      this.isSave = true;
      this.reqService.updateDoTenken( // sendSocket:02作業指示の編集（するしない後日および部品代） // sendSocket:13するしない後日編集
        this.uketsukeExtendsId,
        doTenken,
        item.sknInspectId
      ).then((res) => {
        const userService = new UserService();
        userService.autoSaveAk7(); // sendSocket:ソケット仮34
      });
    }
  }

  // firstDoTenken(item: InspectionItem, doTenken: any) {
  //   if (item.doTenken === 0) {
  //     item.doTenken = doTenken;
  //     this.updateDoTenken(item);
  //     this.updateInspectDoTenken(item);
  //     this.$forceUpdate();
  //     this.isSave = true;
  //     this.reqService.updateDoTenken(
  //       this.uketsukeExtendsId,
  //       doTenken,
  //       item.sknInspectId
  //     );
  //   }
  // }

  validateInshidai(rule: any, value: number, callback: any) {
    if (value == null ) {
      callback(new Error(MESSAGE.InvalidInshidai));
    } else {
      callback();
    }
  }

  validateRyoukinRank(rule: any, value: number, callback: any) {
    if (value == null ) {
      callback(new Error(MESSAGE.InvalidRyoukinRank));
    } else {
      callback();
    }
  }

  ryoukinLabel(ryoukin: Hikazei3) {
    return (
      this.utils.getNumberThousandSeparate(ryoukin.hikazei3Kingaku) +
      "円"
    );
  }

  onTaxDialogOpened() {
    this.$refs.taxForm.validate();
  }

  onShowTax(isShow: boolean) {
    this.displayDialogTax = isShow;
    if (isShow && !this.isSetFormData) {
      this.isSetFormData = true;
      this.reqService.getRyoukinRank().then(res => {
        if (res) {
          this.listRyoukinRank = res as HikazeiRyoukin;
        }
      });
      if (this.costData.houteiHiyou) {
        const houteiHiyou = this.costData.houteiHiyou;
        this.formData.zeiJibaisekiZk = houteiHiyou.zeiJibaisekiZk;
        this.formData.zeiJibaisekiZn = houteiHiyou.zeiJibaisekiZn;
        this.formData.zkJibaisekiCd = houteiHiyou.jibaisekiCd;
        this.formData.zeiJibaisekiMonthCnt = houteiHiyou.zeiJibaisekiMonthCnt;
        this.formData.zeiWeightTax = houteiHiyou.zeiWeightTax;
        this.formData.zkWeightTaxCd = houteiHiyou.weightTaxCd;
        this.formData.ryoukinRankCd = houteiHiyou.ryoukinRankCd ? houteiHiyou.ryoukinRankCd : null;
        this.formData.zeiInshidaiZn = houteiHiyou.zeiInshidaiZn;
        this.formData.zeiInshidaiZk = houteiHiyou.zeiInshidaiZk;
        this.formData.zeiInshidaiGenka = houteiHiyou.zeiInshidaiZn;
      }
      setTimeout(() => {
        this.onTaxDialogOpened();
      }, 500);
    }
  }

  setInshidai() {
    this.formData.zeiInshidaiZk = this.formData.zeiInshidaiZn;
    this.formData.zeiInshidaiGenka = this.formData.zeiInshidaiZn;
  }

  setRyoukinRank() {
    const ryoukin = this.listRyoukinRank.ryoukinRank.filter(
      (data: any) => data.ryoukinRankCd == this.formData.ryoukinRankCd);
    if (ryoukin.length !== 0) {
      this.formData.zeiInshidaiZn = ryoukin[0].hikazei3Kingaku;
      this.formData.zeiInshidaiZk = this.formData.zeiInshidaiZn;
      this.formData.zeiInshidaiGenka = this.formData.zeiInshidaiZn;
    }
  }

  onSubmitTax() {
    this.$refs.taxForm.validate((valid: boolean) => {
      if (valid) {
        this.displayDialogTax = false;
        this.formData.zeiInshidaiZk = this.formData.zeiInshidaiZn;
        const data: JuuryouzeiJibaiseikiSave = {
          sknUketsukeExtendsId: this.uketsukeExtendsId,
          ...this.formData
          // ,
          // zeiJibaisekiMonthCnt: null,
          // zkJibaisekiCd: null,
          // zeiJibaisekiZn: null,
          // zeiJibaisekiZk: null,
          // zkWeightTaxCd: null,
          // zeiWeightTax: null
        };
        this.updateTax(this.formData);
        // this.reqService.saveTax(data);
        this.reqService.saveRyoukinRank(data);
        this.updateRyoukinRankCd(this.formData.ryoukinRankCd);
        setTimeout(() => {
          const userService = new UserService();
          userService.getShohiyou();
        }, 500);
      }
    });
  }

  /** 2022-10-19 sh #8066(BQR974) Choose from multiple parts. [START] */
  hasMultipleBuhin(subItem: any) {
    if (subItem && subItem.hasOwnProperty("isHasMultipleBuhin") && subItem.isHasMultipleBuhin == 1) {
      return "";
    }
    return "d_ni";
  }
  /** 2022-10-19 sh #8066(BQR974) Choose from multiple parts. [END] */
}
